export default "__VITE_ASSET__Dij9yHsF__"